import type { FaireProductEntity } from "../../entity_types/product";

export const p_ejtecbxlsz: FaireProductEntity = {
  token: "p_ejtecbxlsz",
  type: "product",
  name: 'The "One Tripper" HUGE Mesh Market Bag | Zero Waste',
  brandToken: "b_69jqux09qb",
  brandName: "Me Mother Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/11872e809d34b389bd4f4e630100b1409e8776572d59162142a9f09b0e42852f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5bcdbb8c33db407c27ac2279652a28a217d5270f7cf1cbbbc0a3242dfde0252d.jpeg",
    "https://cdn.faire.com/fastly/943dfe3e82de69ed4fc704fae02c113cf6bbd315e320e56d03d28ad015af3160.jpeg",
    "https://cdn.faire.com/fastly/852277c25ad4896977f6b8667fea4a795677fe68c465daa9eb305ca06220593f.jpeg",
    "https://cdn.faire.com/fastly/fc2e161ea49f28069b94ef577a6edd7815ae26cb89bddfd2885353b45043ccd2.jpeg",
    "https://cdn.faire.com/fastly/028f4f15892af4ebab5fddc58bfda928b49d3b86bc7278bc3a4f0eddc3f22080.jpeg",
    "https://cdn.faire.com/fastly/228b607f856e586d6c4b158aaf5e93b066b3614f5fffea714445efc8221f14c0.jpeg",
  ],
  priceDollars: 5.98,
  description:
    'Available in 3 Colors: Natural, Tropical Blue, Sage Green\n\nDurable and washable, these mesh market bags can be used for a really long time, eliminating countless plastic bags that pollute our Mother Earth! Our "One Tripper" bag is EXTRA large replacing up to 4 plastic bags each grocery haul!\n\nThey are 100% cotton and free from any synthetic plastic-based materials such as polyester or nylon. GOTS organic cotton and audited by BSCI social compliance for quality working conditions and fair wage workers.\n\nMultipurpose- Perfect for grocery hauls or farmers markets, these bags hold up to 35 lbs. They\'re also great for toy or home organization and even laundry!\n\nLength- Handle 12" - perfect for over the shoulder. Empty bag length: 34"\n\nCare Instructions- Machine wash on a gentle cycle or hand wash and line dry.\n\nPackaging: Kraft paper tag with UPC. ',
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:15.268Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
